import React from 'react';
import { BsEye } from 'react-icons/bs';
import styles from './AudioPlayer.module.css';

const AudioPlayer = ({ 
  episode, 
  isPlaying, 
  onPlayPause, 
  onRewind, 
  currentTime, 
  duration, 
  playbackTime,
  onViewDetails,
  onDeleteEpisode
}) => {
  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const hasAudio = episode.audio_files && episode.audio_files.length > 0;

  if (!hasAudio) {
    return null;
  }

  return (
    <>
      {(isPlaying || playbackTime > 0) && (
        <div className={styles.timeContainer}>
          <span className={styles.timeDisplay}>
            {formatTime(isPlaying ? currentTime : playbackTime)} / {formatTime(duration)}
          </span>
        </div>
      )}
      <div className={styles.buttonsContainer}>
        {isPlaying && (
          <button 
            className={styles.rewindButton}
            onClick={onRewind}
            title="Rewind 10 seconds"
          >
            <span className={styles.rewindIcon}>⏪</span>
          </button>
        )}
        <button 
          className={styles.playButton}
          onClick={() => onPlayPause(episode)}
          title={isPlaying ? "Pause" : "Play"}
        >
          <span className={styles.playIcon}>
            {isPlaying ? "⏸" : "▶"}
          </span>
        </button>
        <button 
          className={styles.viewButton}
          onClick={onViewDetails}
          title="View Details"
        >
          <BsEye className={styles.eyeIcon} />
        </button>
        <button 
          className={styles.deleteButton}
          onClick={() => onDeleteEpisode(episode)}
          title="Delete episode"
        >
          <span className={styles.trashIcon}>🗑</span>
        </button>
      </div>
    </>
  );
};

export default AudioPlayer;
